const EMPTY_ALT_KEY = '__empty__';

export const dedupeAltOptions = (options = []) => {
  const map = new Map();

  options.forEach((option) => {
    const altText = option.altText ?? '';
    const key = altText === '' ? EMPTY_ALT_KEY : altText;
    const existing = map.get(key);

    if (existing) {
      if (option.sourceLabel && !existing.sourceLabels.includes(option.sourceLabel)) {
        existing.sourceLabels.push(option.sourceLabel);
      }
      return;
    }

    map.set(key, {
      altText,
      sourceLabels: option.sourceLabel ? [option.sourceLabel] : [],
      sourceType: option.sourceType,
    });
  });

  return [...map.values()];
};

/**
 * Resolves Shopify alt from selected Master usage options per PCS-11145 §14.
 */
export default function resolveSyncAltAutomatically(options = []) {
  const deduped = dedupeAltOptions(options);

  if (!deduped.length) {
    return { resolved: '', needsUserChoice: false, options: deduped };
  }

  if (deduped.length === 1) {
    return { resolved: deduped[0].altText, needsUserChoice: false, options: deduped };
  }

  const nonEmpty = deduped.filter((option) => option.altText !== '');

  if (nonEmpty.length === 1) {
    return { resolved: nonEmpty[0].altText, needsUserChoice: false, options: deduped };
  }

  if (nonEmpty.length === 0) {
    return { resolved: '', needsUserChoice: false, options: deduped };
  }

  return { resolved: null, needsUserChoice: true, options: deduped };
}
